<template>
  <div>
    <div align="left">
      <br />
      <h5 class="h5 mb-1 text-primary">
        <b>Benefits</b>
      </h5>
      <br />
    </div>
    <b-card class="text-left">
      <b class="h6 font-weight-bold">Edit Benefits</b>
      <b-row class="mt-4">
        <b-col>
          <b-form-group id="fieldset-1" label="Title (Bahasa)" label-for="input-1">
            <input
              placeholder="Title In Bahasa"
              v-model="items.title.id"
              v-validate="'required|min:5|max:30'"
              name="title_id"
              data-vv-as="Title Bahasa"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_id-feedback">{{ veeErrors.first('title_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Title (English)" label-for="input-1">
            <input
              placeholder="Title In English"
              v-model="items.title.en"
              v-validate="'required|min:5|max:30'"
              name="title_en"
              data-vv-as="Testimonial English"
              class="form-control"
            />
            <b-form-invalid-feedback id="input-title_en-feedback">{{ veeErrors.first('title_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group id="fieldset-1" label="Description (Bahasa)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="items.description.id"
              v-validate="'required|min:5|max:30'"
              name="description_id"
              data-vv-as="Description Bahasa"
              class="form-control"
              placeholder="Description In Bahasa Indonesia"
            ></textarea>
            <b-form-invalid-feedback
              id="input-description_id-feedback"
            >{{ veeErrors.first('description_id') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="fieldset-1" label="Description (English)" label-for="input-1">
            <textarea
              id="textarea"
              v-model="items.description.en"
              v-validate="'required|min:5|max:30'"
              name="description_en"
              data-vv-as="Testimonial English"
              class="form-control"
              placeholder="Description In English"
            ></textarea>
            <b-form-invalid-feedback
              id="input-description_en-feedback"
            >{{ veeErrors.first('description_en') }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group id="fieldset-1" label="Image" label-for="input-1"></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>
                  &nbsp;
                  Image
                  <sup
                    class="text-secondary pl-3 mr-5 pr-5"
                  >(2 Mb)</sup>
                </b-col>
                <b-col class="text-right" align="right">
                  <input
                    type="file"
                    ref="file"
                    v-validate="'image|dimensions:500,500|ext:jpg,png,gif,jpeg'"
                    name="image"
                    style="display: none"
                    v-on:change="onChangeFileUpload()"
                  />
                  <b-button
                    @click="$refs.file.click()"
                    v-show="!file && !items.image"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="file || items.image"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.file.click()"
                    v-show="file || items.image"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col class="pr-0">
          <b-form-group id="fieldset-1" label="Status" label-for="input-1">
            <b-form-radio-group
              id="radio-group-1"
              v-model="items.status"
              :options="options"
              v-validate="'required'"
              name="radio-options"
              data-vv-as="Status"
            ></b-form-radio-group>
            <p
              class="text-danger"
              style="width:100%;margin-top:.25rem;font-size: 80%;"
            >{{ veeErrors.first('radio-options') }}</p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="text-right">
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">Save</b-button>
          <router-link :to="{name: 'pxBenefits'}">
            <b-button size="lg" variant="outline-secondary">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-show="!file" v-if="items.image" width height="400px" :src="items.image" />
      <img v-show="file" v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import dataService from '../dataService';

export default {
  data() {
    return {
      items: [],
      modalImage: false,
      widthImage: null,
      heightImage: null,
      urlImage: '',
      file: '',
      loading: false,
      selected: '',
      options: [
        { text: 'Publish', value: 'publish' },
        { text: 'Archive', value: 'archive' },
      ],
    };
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    this.$store.dispatch('benefitsModule/getBenefit', this.$route.params.id);
  },
  created() {
    this.$store.watch(
      state => state.benefitsModule.benefits_id,
      (newValue, oldValue) => {
        this.items = newValue;
        // Do whatever makes sense now
        if (this.items.length === 0) {
          this.loading = true;
        } else {
          this.loading = false;
        }
      },
    );
  },
  methods: {
    put() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append('image', this.file);
          formData.append('title_id', this.items.title.id);
          formData.append('title_en', this.items.title.en);
          formData.append('description_id', this.items.description.id);
          formData.append('description_en', this.items.description.en);
          formData.append('status', this.items.status);
          this.$store
            .dispatch('benefitsModule/putBenefit', {
              id: this.$route.params.id,
              formData,
            })
            .then((response) => {
              this.loading = false;
              this.$router.push({ name: 'pxBenefits' });
              this.$swal({
                type: 'success',
                title: 'Your work has been saved',
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              console.log(error);
            });
        } else {
          this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
        }
      });
    },
    onChangeFileUpload() {
      this.file = this.$refs.file.files[0];
      const input = this.$refs.file;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
  computed: {
    isCompleted() {
      return (
        this.items.status
        // this.items.image &&
        && this.items.title.id
        && this.items.title.en
        && this.items.description.id
        && this.items.description.en
      );
    },
  },
};
</script>

<style>
</style>
